module.exports = __webpack_public_path__ + "img/email-icon-black.01c0dddf.svg";